// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2wQIU","ranges":"BmiRanges_ranges__2IbY6"};